import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const wrapperOnMobiles = media.tablet`
  padding: 0 19px;
  margin-top: 0;
`;

export const Wrapper = styled.div`
  margin-top: 30px;

  * {
    user-select: none;
  }

  ${wrapperOnMobiles};
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 18px 0 14px 0;

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #292a2b;
    margin: 0 0 0 10px;
  }
`;
